import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full overflow-hidden bg-gradient-to-b from-[#0c1425] to-[#111c35] px-4 py-12 md:py-20" data-id="element-94">
      {/* Decorative Stars */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-95">
        {[...Array(20)].map((_, i) => <div key={i} className="star" style={{
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        width: `${Math.random() * 3 + 1}px`,
        height: `${Math.random() * 3 + 1}px`,
        animationDelay: `${Math.random() * 5}s`,
        opacity: Math.random() * 0.5 + 0.2
      }} data-id="element-96" />)}
      </div>

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-97">
        {/* Moon Icon */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1
      }} className="mb-8 text-amber-400/80" data-id="element-98">
          <Moon size={48} strokeWidth={1.5} className="drop-shadow-[0_0_10px_rgba(251,191,36,0.3)]" data-id="element-99" />
        </motion.div>

        {/* The 2:13am Scene - Poetic Lead */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5,
        duration: 1
      }} className="mb-12 space-y-4 font-serif italic text-lg md:text-xl text-amber-100/70 leading-relaxed" data-id="element-100">
          <p data-id="element-101">Son las 2:13am.</p>
          <p data-id="element-102">No es la primera vez.</p>
          <p data-id="element-103">Ni la tercera.</p>
          <p data-id="element-104">Ya perdiste la cuenta.</p>
        </motion.div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1,
        duration: 0.8
      }} className="text-4xl md:text-6xl font-bold text-cream mb-6 leading-tight" data-id="element-105">
          Tu bebé no está "mal". <br data-id="element-106" />
          <span className="text-gold-gradient" data-id="element-107">
            Tu sistema de sueño está roto.
          </span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.2,
        duration: 0.8
      }} className="text-xl md:text-2xl text-amber-50 mb-10 max-w-2xl" data-id="element-108">
          Reset en 7 noches: menos despertares sin dejarlo llorar.
        </motion.p>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 1.4,
        duration: 0.8
      }} className="mb-12 w-full max-w-3xl" data-id="element-109">
          <img src="https://cdn.magicpatterns.com/uploads/m7UeyXZhgJjfrGrcwhUrX3/reset_del_sueno_2.png" alt="Mamá con bebé durmiendo y guía Noches en Paz en tablet y celular" className="w-full h-auto rounded-lg shadow-2xl shadow-amber-900/20" data-id="element-110" />
        </motion.div>

        {/* CTA */}
        <motion.a href="#comprar" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.6,
        duration: 0.8
      }} className="btn-gold inline-flex items-center px-8 py-4 text-lg font-semibold rounded-full shadow-lg" data-id="element-111">
          Descarga Noches en Paz <span className="ml-2" data-id="element-112">→</span>
        </motion.a>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.8
      }} className="mt-4 text-sm text-amber-200/60" data-id="element-113">
          Para que dejes de adivinar… y vuelvas a dormir.
        </motion.p>
      </div>
    </section>;
}